import ConfigService from 'shared/services/config.service';

export const getDefaultLabOriginId = () => ConfigService.getConfigValue('Settings', 'DefaultLabOriginId') || '10';
